import { render } from "./RegionDashBoardsRepresentativeInfoList.vue?vue&type=template&id=5a39255e&scoped=true&ts=true"
import script from "./RegionDashBoardsRepresentativeInfoList.vue?vue&type=script&lang=ts"
export * from "./RegionDashBoardsRepresentativeInfoList.vue?vue&type=script&lang=ts"

import "./RegionDashBoardsRepresentativeInfoList.vue?vue&type=style&index=0&id=5a39255e&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a39255e"]])

export default __exports__